import axios from "@/libs/api.request";
export const getDicts = (dictType) => {
  return axios.request({
      url: "front/v1/common/dict-data",
      params:{
        dictType
      },
      method: "get"
  });
};
